<template>
  <b-btn-toolbar class="layers-toolbar">
    <span class="text-center version-info">Wersja: {{ version }}</span>
    <!-- <auth-b-btn variant="primary" title="Pobierz szablon" class="d-none d-lg-inline-block d-xl-inline-block" id="download-tool" v-if="getTemplateTool" @click="showDownloadTemplate()" :permissionId="'Templates_download'">
        <icon name="download"/>
      </auth-b-btn> -->
  </b-btn-toolbar>
</template>

<script>
import { mapGetters } from 'vuex';
import { WINDOW_DOWNLOAD_TEMPLATE_SHOW } from '../store/mutations.type';

export default {
  data: function() {
    return {
      version: null
    };
  },

  computed: {
    ...mapGetters(['getTemplateTool', 'styles'])
  },
  methods: {
    showDownloadTemplate() {
      this.$store.commit(WINDOW_DOWNLOAD_TEMPLATE_SHOW);
    }
  },
  mounted() {
    this.version = process.env.VUE_APP_IMAGE_VERSION
      ? process.env.VUE_APP_IMAGE_VERSION
      : '';
  }
};
</script>

<style>
.layers-toolbar {
  margin-top: auto;
  background-color: #fff;
  -webkit-flex: none;
  flex: none;
}

.layers-toolbar .btn {
  z-index: 10;
}

.layers-toolbar * {
  border-radius: 0 !important;
}

.layers-toolbar .btn {
  z-index: 10;
}
</style>
